import React, { useEffect, useState } from 'react'
import ComputoAnual from './ComputoAnual'
import { useAuth } from 'context/AuthProvider'
import { apiEmpleadosService } from 'services/apiEmpleadosService';
import { Button, Card, CardHeader, Col, FormGroup, Input, Label, Pagination, PaginationItem, PaginationLink, Row, Table } from 'reactstrap';

const ComputoAnualImpl = () => {
    const { empresa } = useAuth();
    const [anno, setAnno] = useState(new Date().getFullYear()) 
    const [empleados, setEmpleados] = useState([])
    const [page, setPage] = useState(1)
    const pageSize = 10
    const maxPagesToShow = 5


    const [multiplicarHoras, setMultiplicarHoras] = useState(1)


    const handleCambioDiasHoras = () =>{
        if(multiplicarHoras === 8) {
            setMultiplicarHoras(1)
        }else{
            setMultiplicarHoras(8)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiEmpleadosService.getAllFiltered(empresa.id,null, null, null, new Date().toISOString().split("T")[0], "asc", 0, 1000)
            setEmpleados(response.content);
          
        }
        fetchData();
    }, [empresa.id])

    const totalPages = Math.max(1, Math.ceil(empleados.length / pageSize))

    useEffect(() => {
        if (page > totalPages) {
            setPage(totalPages)
        }
    }, [page, totalPages])

    const start = (page - 1) * pageSize
    const empleadosPaginados = empleados.slice(start, start + pageSize)

    const goToPage = (nextPage) => {
        const clamped = Math.min(Math.max(nextPage, 1), totalPages)
        setPage(clamped)
    }

    const getVisiblePages = () => {
        if (totalPages <= maxPagesToShow) {
            return Array.from({ length: totalPages }, (_, i) => i + 1)
        }
        const half = Math.floor(maxPagesToShow / 2)
        let startPage = page - half
        let endPage = page + half
        if (maxPagesToShow % 2 === 0) {
            endPage -= 1
        }
        if (startPage < 1) {
            startPage = 1
            endPage = maxPagesToShow
        }
        if (endPage > totalPages) {
            endPage = totalPages
            startPage = totalPages - maxPagesToShow + 1
        }
        return Array.from(
            { length: endPage - startPage + 1 },
            (_, i) => startPage + i
        )
    }
    

    

    return (
        <>
            <Card >
                <CardHeader >
                    <Row>
                        <Col >

                        <FormGroup row >
                            <Label htmlFor='anno' sm={6}>  Computo Anual de {multiplicarHoras=== 8 ? "horas" : "días"} del</Label>
                            <Col sm={4} className='ml--5' >
                                <Input id="anno" name="anno" type="number" value={anno} onChange={(e) => setAnno(e.target.value)}></Input>
                            </Col>
                        </FormGroup>
                            
                        </Col>
                        
                        <Col className='text-right ' sm={3}>
                            <Button color='primary' onClick={handleCambioDiasHoras}>Ver en {multiplicarHoras=== 8 ? "días" : "horas"}</Button>
                        </Col>
                    </Row>
                </CardHeader>
                <Table className="text-center table-flush" responsive>
                    <thead className="thead-light">
                        <tr>
                            <th className='text-left'>Empleado</th>
                            <th>Laborables</th>
                            <th>Vacaciones</th>
                            <th>Festivos</th>
                            <th>Ausencias</th>
                            <th>Bajas</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        {empleadosPaginados.map((empleado, index) => (
                            <tr key={index}>
                                <ComputoAnual  empleado={empleado} anno={anno} multiplicarHoras={multiplicarHoras}></ComputoAnual>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {empleados.length > pageSize && (
                    <div className="d-flex justify-content-center p-3">
                        <Pagination aria-label="Paginación de empleados">
                            <PaginationItem disabled={page === 1}>
                                <PaginationLink previous onClick={() => goToPage(page - 1)} />
                            </PaginationItem>
                            {getVisiblePages().map((pageNumber) => (
                                    <PaginationItem active={pageNumber === page} key={pageNumber}>
                                        <PaginationLink onClick={() => goToPage(pageNumber)}>
                                            {pageNumber}
                                        </PaginationLink>
                                    </PaginationItem>
                            ))}
                            <PaginationItem disabled={page === totalPages}>
                                <PaginationLink next onClick={() => goToPage(page + 1)} />
                            </PaginationItem>
                        </Pagination>
                    </div>
                )}


            </Card>
        </>
    )
}

export default ComputoAnualImpl
